import apiClient from "./client";

export async function getAdminDisputesSummary(token, days = 30) {
  const res = await apiClient.get("/admin/disputes/v2/summary", {
    params: { days },
  });
  return res.data;
}

export async function listAdminDisputes(token, { status = "open", page = 1, page_size = 25 } = {}) {
  const res = await apiClient.get("/admin/disputes/v2/list", {
    params: { status, page, page_size },
  });
  return res.data;
}

export async function getAdminDisputeDetail(token, disputeId) {
  const res = await apiClient.get(`/admin/disputes/v2/${encodeURIComponent(disputeId)}`);
  return res.data;
}

export async function getAdminDisputeLedger(token, disputeId) {
  const res = await apiClient.get(`/admin/disputes/v2/${encodeURIComponent(disputeId)}/ledger`);
  return res.data;
}

export async function setAdminDisputeHold(token, { dispute_id, action, note }) {
  const res = await apiClient.post("/admin/disputes/v2/hold", { dispute_id, action, note });
  return res.data;
}
